import "./DroppableSpacer.css";
import { useDrop } from 'react-dnd'

export type DroppableSpacerTypes = "question" | "end";

type DroppableSpacerProps = {
    position: number;
    accept: DroppableSpacerTypes;
    children?: any;
}

export const DroppableSpacer = ({ position, accept, children } : DroppableSpacerProps) => {
    const [{ canDrop, isOver }, drop] = useDrop(() => ({
        accept,
        drop: () => ({ name: "spacer" , position }),
        collect: (monitor) => ({
          isOver: monitor.isOver(),
          canDrop: monitor.canDrop(),
        }),
      }))

    const isActive = canDrop && isOver
    let backgroundColor = '#222'
    
    if (isActive) {
        backgroundColor = 'darkgreen'
    } else if (canDrop) {
        backgroundColor = 'darkkhaki'
    }

    const style = isActive ? 
        { 
            // backgroundColor: 'darkgreen', 
            // transform: "scale(1.25)",
            opacity: 0.2,
            filter: "brightness(1,25)",
            // outline: "1px solid black",
        } : 
        {};

    // console.log("[DroppableSpacer] isActive: ", isActive);
    // console.log("[DroppableSpacer] canDrop: ", canDrop);
    // console.log("[DroppableSpacer] isOver: ", isOver);

    return (
        <div 
            ref={drop}
            className="droppable-spacer"
            style={style}
            // style={{backgroundColor: "lightblue", color: "black", display: "flex", flexDirection: "column"}}
            data-testid={"droppable-spacer-" + accept + "#" + position}
        >
            {/* <div style={{display: "flex"}}>
                {position} | {isActive ? 'Release' : 'Drag here'}
            </div> */}
            {children &&
                <div 
                    className="droppable-spacer-children"
                    // style={{marginTop: "4px"}}
                >
                    {children}
                </div>
        }
            {!children &&
                <div className="droppable-spacer-drop-zone">
                    {}
                </div>
            }
            
        </div>

    )
}